import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import SubscriptionsCard from "../../Components/SubscriptionsCard/index";

const propTypes = {};

const defaultProps = {};

class Subscriptions extends Component {
    state = {};

    options = () => {
        return (
            <React.Fragment>
                <a href="/subscriptions/new" className="btn btn-pill btn-outline-primary">Criar Nova Assinatura</a>
            </React.Fragment>
        );
    };

    render() {
        return (
            //<AuthenticatedTemplate title="Assinaturas" options={this.options()}>
            <AuthenticatedTemplate title="Assinaturas">
                <SubscriptionsCard/>
            </AuthenticatedTemplate>
        );
    }
}

Subscriptions.propTypes = propTypes;
Subscriptions.defaultProps = defaultProps;

export default Subscriptions;
